import Moment from 'moment/moment';
import { dateFormats } from '../../../common/constants/dateFormats';

const StatusCodes = 'StatusCodes';
const PriceLevels = 'PriceLevels';
const PaymentMethods = 'PaymentMethods';

export const offerSectionsWithSelectAllEnabled = (
  offerData,
  priceChartLoaded,
  zoneId
) => {
  const missingOfferData = {};
  missingOfferData.priceChartLoaded = priceChartLoaded;
  missingOfferData.list = [];
  if (offerData.paymentMethods.length < 1 && zoneId) {
    missingOfferData.list.push(PaymentMethods);
  }

  if (!offerData.groups) return missingOfferData;

  offerData.groups.forEach((group) => {
    if (group.statusCodes && group.statusCodes.length < 1 && zoneId) {
      missingOfferData.list.push(StatusCodes);
    }
    if (
      group.priceLevels &&
      group.priceLevels.length < 1 &&
      !priceChartLoaded
    ) {
      missingOfferData.list.push(PriceLevels);
    } else if (
      group.priceLevels &&
      group.priceLevels.length < 1 &&
      priceChartLoaded
    ) {
      // this means the price levels were select-all in BO, but the priceChart has already been fetched
      missingOfferData.getPriceLevelsFromStore = true;
    }
  });
  return missingOfferData;
};

/**
 * Renames the offer object properties to make more sense on front end store
 * @param  {[object]} offer offer object from api
 * @param { string } offerName - offer name from save offer or transformed offername for new offers
 * @return {[object]} updated offer object
 */
export const alignOfferProperties = (offer, offerName) => {
  const updatedOffer = {
    ...offer,
    offerName,
    purchaseFlowDescription: offer.description,
    popupNotificationEnabled: offer.popupNotificationEnabled,
    popupNotification: offer.popupNotification,
    ticketLimit: offer.maxQty,
    offerLookupId: offer.lookupId,
    promoCodes: offer.offerRestrictions,
  };

  if (updatedOffer.hasOwnProperty('aXSPromotion')) {
    updatedOffer.axsPromotion = updatedOffer.aXSPromotion;
    delete updatedOffer.aXSPromotion;
  }

  const storageFormat = dateFormats.API_DATE_TIME_FORMAT;
  const onSale = Moment(updatedOffer.onSaleDate).format(storageFormat);
  const offSale = Moment(updatedOffer.offSaleDate).format(storageFormat);
  updatedOffer.onSaleDate = onSale;
  updatedOffer.offSaleDate = offSale;

  delete updatedOffer.maxQty;
  delete updatedOffer.lookupId;
  delete updatedOffer.offerRestrictions;
  return updatedOffer;
};



// WEBPACK FOOTER //
// ./src/common/lib/offers/index.js